import classNames from "classnames"
import React from "react"
import { CalendarEventAvailabilitySlot } from "../../../../../api/backend/backend-api"
import { useLabels } from "../../../../contents/hooks"
import { formatTime } from "../../../utils/format"
import classes from "./EventCalendarTimeButton.module.css"

interface Props {
  slot: CalendarEventAvailabilitySlot
  selected?: boolean
  onSelect: () => void
  onConfirm: () => void
  className?: string
}

const EventCalendarTimeButton = ({
  onConfirm,
  onSelect,
  slot,
  selected,
  className,
}: Props) => {
  const { getLabel } = useLabels()
  return (
    <div className={`${classes.root} ${className ?? ""}`}>
      <div
        className={classNames(classes.button, classes.timeButton, {
          [classes.timeButtonSelected]: selected,
        })}
        onClick={onSelect}
      >
        {formatTime(slot.from)} - {formatTime(slot.to)}
      </div>
      <div
        className={classNames(classes.button, classes.confirmButton, {
          [classes.confirmButtonVisible]: selected,
        })}
        onClick={onConfirm}
      >
        {getLabel("calendar", "confirm-label")}
      </div>
    </div>
  )
}

export default EventCalendarTimeButton
